import { useEffect, useState } from "react"
import Copyright from "../common/Copyright"
import SimpleSelection from "../common/SimpleSelection"
import MainContainer from "../common/MainContainer"
import { useProject } from "../../context/ProjectContext"
import { itemSelection } from "../../models/itemSelection.model"
import DownloadChip from "../common/ActionChip/DownloadChip"
import ClosedTicketsReport from "./ClosedTickets"
import './index.css'


interface OperationReportsProps {
  setBlockScreen: (p: boolean) => void
}

const OperationReports: React.FC<OperationReportsProps> = ({
  setBlockScreen,
}) => {

  const { selectedProject } = useProject()

  const options: itemSelection[] = [
    { 'id': 'RECT', 'label': 'Tickets Cerrados' },
  ]

  const defaultReport = options[0] ?? { id: '', label: '' }
  const [reportSelected, setReportSelected] = useState<itemSelection>(defaultReport)

  const handleChange = (event: React.ChangeEvent<HTMLInputElement> | { 'target': { 'name': any, 'value': any } }): void => {
    setReportSelected({
      ...reportSelected,
      [event.target.name]: event.target.value
    });
  }

  return (
    <>
      <MainContainer>
        <div className="reports-actions-bar">
          <span className="reports-actions-bar-selector">

            <SimpleSelection
              label="Reporte"
              options={options}
              name={"entity"}
              value={reportSelected}
              onChange={handleChange}
            />
          </span>
          {selectedProject && (
            <span className="reports-actions-bar-add-btn">
              <DownloadChip
                onClick={() => { }}
                label='Exportar a PDF'
              />
            </span>
          )}
        </div>

        {reportSelected.id === 'RECT' && (
          <ClosedTicketsReport setBlockScreen={setBlockScreen} />

        )}


      </MainContainer>

      <Copyright marginBottom={'1rem'} />
    </>
  );
}

export default OperationReports;